import {
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Stack,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { ReactNode } from 'react';


type Props = {
  icon: ReactNode;
  contactText: ReactNode;
  dupesIndicator: ReactNode;
  onDelete: () => void;
}

export const ContactListItem = ({ icon, contactText, onDelete, dupesIndicator }: Props) => {

  return (
    <>
      <ListItem>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <ListItemText sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
          {contactText}
        </ListItemText>
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ ml: 1, flexShrink: 0 }}>
          {dupesIndicator}

          <IconButton edge="end" size='small' onClick={onDelete}>
            <ClearIcon />
          </IconButton>
        </Stack>
      </ListItem>
    </>
  );
};


